import { ApiResponse, getRaw } from 'services/api';
import { EMAIL, IN_APP } from 'constants/messageMediums';

export const PREVIEW_NON_HTML_TEMPLATE_URL = '/i/templates/renderhtml?';
export const PREVIEW_HTML_TEMPLATE_URL = '/templates/showHtml?';
export const TEMPLATE_DATA_BY_ID_URL = '/templates/templateData.json?';

/**
 * Get endpoint for fetching the preview of a template
 * @param templateId
 * @param messageMedium
 * @param showAndroid (optional)
 * @param showExpanded (optional)
 * @param showExpanded (optional)
 * @param locale (optional)
 */
export const previewTemplate = (
  templateId: number,
  messageMedium: string,
  showAndroid?: boolean,
  showExpanded?: boolean,
  showLighthouseVersion?: boolean,
  locale?: string,
): Promise<ApiResponse> => {
  // IN_APP and EMAIL are provided by a different URL than the other message medium previews.
  let url =
    messageMedium === IN_APP || messageMedium === EMAIL
      ? PREVIEW_HTML_TEMPLATE_URL
      : PREVIEW_NON_HTML_TEMPLATE_URL;

  url += `templateId=${templateId}`;

  if (showLighthouseVersion) {
    url += '&showLighthouseVersion=true';
  }

  if (locale) {
    url += `&locale=${locale}`;
  }

  if (showAndroid) {
    url += '&showAndroid=true';
  }

  if (showExpanded) {
    url += '&showExpanded=true';
  }
  return getRaw(url);
};

/**
 * Get endpoint for fetching the inApp content of a template
 * @param {number} templateId
 */
export const getInAppContent = (templateId: number): Promise<ApiResponse> =>
  getRaw(`${TEMPLATE_DATA_BY_ID_URL}templateId=${templateId}`);
